import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type {
	AiSuggestionsPlugin,
} from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';

import type { DiscardSuggestionAction } from './types';

export const discardSuggestionAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => DiscardSuggestionAction = (api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(id: string): boolean => {
		let found = false;
		api?.core?.actions.execute(({ tr }) => {
			const pluginState = api?.aiSuggestions?.sharedState.currentState();
			if (!pluginState?.suggestionById.get(id)) {
				return tr;
			}
			found = true;
			tr.setMeta(aiSuggestionsPluginKey, { action: 'REMOVE_SUGGESTION', id });
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});
		return found;
	};
